import src from "IMAGE";
export default { src, width: 405, height: 124, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAN0lEQVR42jXAoREAUAQAUPuZwg7ubKMquqL4d6ponp88cPfMNLOImBkiQkRVhe5+p6qYWUR29wMLqB9CC116KgAAAABJRU5ErkJggg=="};
